const BulletPointEmptyIcon = ({ ...others }) => {
  return (
    <svg
      {...others}
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="5" cy="5.00977" r="4.5" stroke="#A6C84D" />
    </svg>
  );
};

export default BulletPointEmptyIcon;
